import { connect } from 'react-redux';
import TinyAOFAnalysis from '../views/tiny/TinyAOFAnalysis';

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch) => ({});

const TinyAOFAnalysisContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinyAOFAnalysis);

export default TinyAOFAnalysisContainer;


